import { X } from "lucide-react";
import { useTranslation } from "../i18n";

type palletType = {
    Zone: string;
    PalletId: string;
    Collected: boolean;
}

const ZoneStorageSettingsPalletList = ({ batch, pallets, onClose }: { batch: number, pallets: palletType[], onClose: () => void }) => {

    const { t } = useTranslation();

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-card" onClick={(e) => e.stopPropagation()}>
                <div className="modal-card-header">
                    <h2>{t("batch_pallets_title", { batch: String(batch) })}</h2>
                    <button className="modal-close" onClick={onClose}>
                        <X size={18} />
                    </button>
                </div>
                <div className="modal-card-body">
                    {pallets.length > 0 ? (
                        <ul className="zs-pallet-list">
                            {pallets.map((pallet, index) => (
                                <li key={`${pallet.PalletId}-${index}`} className="zs-pallet-row">
                                    <div className="zs-pallet-info">
                                        <span className="zs-pallet-id">{pallet.PalletId}</span>
                                        <span className="zs-pallet-zone">{t("pallet_zone_label", { zone: pallet.Zone })}</span>
                                    </div>
                                    <span className={`zs-pallet-status ${pallet.Collected ? "collected" : "pending"}`}>
                                        {pallet.Collected ? t("pallet_status_collected") : t("pallet_status_pending")}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    ) : <p style={{ color: "var(--color-text-muted)", textAlign: "center" }}>{t("no_data")}</p>}
                </div>
            </div>
        </div>
    );
}

export default ZoneStorageSettingsPalletList;
